
//保留两位小数
const keepTwoNum = function (val) {
    val = Number(val)
    return val.toFixed(2)
}

export default {
    keepTwoNum,
};